import PolicyTermPage from "@app-views/policy-term/policy-term.vue";
import { type RouteRecordRaw } from "vue-router";
export const policyPage = "privacy-policy";
export const policyTermPage = "policy-term";

const policyTermRoutes: RouteRecordRaw[] = [
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})?/policy/:type",
		name: policyPage,
		component: PolicyTermPage,
		meta: {
			isStandalonePage: true
		}
	},
	{
		path: "/:companyId(\\d+)/:systemId(\\d{4,})?/terms/:type",
		name: policyTermPage,
		component: PolicyTermPage,
		meta: {
			isStandalonePage: true
		}
	}
];
export default policyTermRoutes;
